import classNames from 'classnames'
import { SignupFormLayoutProps } from './types'

export const SignupFormLayout = ({
  children,
  className,
  layout,
}: SignupFormLayoutProps): JSX.Element => {
  return (
    <div
      className={classNames(
        'overflow-hidden relative w-full',
        layout === 'split' &&
          'flex flex-col lg:grid lg:grid-flow-col lg:auto-cols-fr lg:overflow-hidden h-full justify-center',
        className,
      )}
    >
      {children}
    </div>
  )
}
